import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row starter-main" }
const _hoisted_5 = {
  key: 1,
  class: "text-center my-5"
}

import { ref, computed, onMounted, watch, nextTick } from "vue";
import { useCrud } from "@/composables/commen/useCrud";
import BaseModal from "@/components/commen/modal/BaseModal.vue";
import BaseForm from "@/components/commen/modal/BaseForm.vue";
// import zeroConfiguration from "@/components/commen/table/zeroConfiguration.vue";
import { useRouter } from "vue-router";
import CommonTable from "@/components/commen/table/CommonTable.vue";

const API_RESOURCE = "common/agents";
const pageTitle = "Workspace Agents";
const title = "Workspace Agents";


export default /*@__PURE__*/_defineComponent({
  __name: 'workspaceAgentsList',
  setup(__props) {

const crud = useCrud(API_RESOURCE);
const router = useRouter();

// --- Table Config ---
const tableConfig = ref({
  columns: [
    { name: "Title", field: "title", sortable: true },
    { name: "Description", field: "description", sortable: true },
  ],
  data: crud.data.value,
  actions: [true],
  loading: true,
});

watch(crud.data, (newVal) => {
  tableConfig.value.data = newVal;
});
watch(crud.isLoading, (newVal) => {
  tableConfig.value.loading = newVal;
});

// --- Modal State ---
const isCreateModalOpen = ref(false);
const isEditModalOpen = ref(false);
const isViewMode = ref(false);

// --- Form Data ---
const newItemData = ref({ title: "", description: "" });
const editingItemData = ref({ _id: "", title: "", description: "" });

// --- Form Fields ---
const createFormFields = [
  {
    key: "title",
    label: "Title",
    type: "text",
    required: true,
    placeholder: "Enter title",
  },
  {
    key: "description",
    label: "Description",
    type: "text",
    required: true,
    placeholder: "Enter description",
  },
];

const editFormFields = computed(() => [
  {
    key: "title",
    label: "Title",
    type: "text",
    required: true,
    placeholder: "Enter title",
    readonly: isViewMode.value,
  },
  {
    key: "description",
    label: "Description",
    type: "text",
    required: true,
    placeholder: "Enter description",
    readonly: isViewMode.value,
  },
]);

// --- Validation ---
const isCreateFormInvalid = computed(
  () => !newItemData.value.title.trim() || !newItemData.value.description.trim()
);
const isEditFormInvalid = computed(
  () =>
    !editingItemData.value.title?.trim() ||
    !editingItemData.value.description?.trim()
);

// --- Handlers ---
const handleEdit = (row: any) => {
  if (!row._id) return;
  editingItemData.value = { ...row };
  isViewMode.value = false;
  isEditModalOpen.value = true;
};

const handleView = (row: any) => {
  isViewMode.value = true;
  editingItemData.value = { ...row };
  isEditModalOpen.value = true;
};

const handleDelete = async (id: string) => {
  if (confirm("Are you sure you want to delete this item?")) {
    await crud.deleteItem(id);
  }
};

const handleSaveCreate = async () => {
  if (isCreateFormInvalid.value) return;
  const payload = { ...newItemData.value };
  const result = await crud.createItem(payload);
  if (result) closeCreateModal();
};

const handleSaveEdit = async () => {
  if (isEditFormInvalid.value) return;
  const { _id, ...updatePayload } = editingItemData.value;
  const result = await crud.updateItem(_id, updatePayload);
  if (result) closeEditModal();
};

// --- Close Modals ---
const closeCreateModal = () => {
  isCreateModalOpen.value = false;
  newItemData.value = { title: "", description: "" };
};

const closeEditModal = () => {
  isEditModalOpen.value = false;
  isViewMode.value = false;
  editingItemData.value = { _id: "", title: "", description: "" };
};

// --- Lifecycle ---
onMounted(async () => {
  await crud.fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/create-workspace-agents')))
        }, " Create New ")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_unref(crud).isLoading)
          ? (_openBlock(), _createBlock(CommonTable, {
              key: 0,
              tableObj: tableConfig.value,
              title: title,
              onEdit: handleEdit,
              onDelete: handleDelete,
              onView: handleView
            }, null, 8, ["tableObj"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1)
            ]))]))
      ])
    ]),
    _createVNode(BaseModal, {
      id: "createNew",
      title: `Create ${pageTitle}`,
      visible: isCreateModalOpen.value,
      onClose: closeCreateModal,
      onSave: handleSaveCreate,
      "save-button-disabled": isCreateFormInvalid.value
    }, {
      body: _withCtx(() => [
        _createVNode(BaseForm, {
          fields: createFormFields,
          modelValue: newItemData.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newItemData).value = $event)),
          onSubmit: handleSaveCreate,
          ref: "createFormRef"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["title", "visible", "save-button-disabled"]),
    _createVNode(BaseModal, {
      id: "editModal",
      title: `${isViewMode.value ? 'View' : 'Edit'} ${pageTitle}`,
      visible: isEditModalOpen.value,
      onClose: closeEditModal,
      onSave: handleSaveEdit,
      "show-save-button": !isViewMode.value,
      "save-button-disabled": isEditFormInvalid.value
    }, {
      body: _withCtx(() => [
        _createVNode(BaseForm, {
          fields: editFormFields.value,
          modelValue: editingItemData.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingItemData).value = $event)),
          onSubmit: handleSaveEdit,
          ref: "editFormRef"
        }, null, 8, ["fields", "modelValue"])
      ]),
      _: 1
    }, 8, ["title", "visible", "show-save-button", "save-button-disabled"])
  ], 64))
}
}

})